import { BaseSyntheticEvent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FQ_BUTTON_COLOR_VARIANTS, FQ_BUTTON_VARIANTS } from '@/components/muiCustomized/FQButton/constant';
import FQButton from '@/components/muiCustomized/FQButton/FQButton';
import { MEDIA_QUERIES_BREAKPOINTS } from '@/globalStyles';

interface IConfirmationButtonsProps {
    className?: string;
    onCancel: (event: BaseSyntheticEvent) => void;
    onSubmit: (event: BaseSyntheticEvent) => void;
    cancelText?: string;
    submitText?: string;
    isDisabled?: boolean;
    cancelButtonVariant?: FQ_BUTTON_VARIANTS;
    submitButtonVariant?: FQ_BUTTON_VARIANTS;
    cancelButtonColor?: FQ_BUTTON_COLOR_VARIANTS;
    submitButtonColor?: FQ_BUTTON_COLOR_VARIANTS;
    justifyContent?: string;
    disabledSubmit?: boolean;
}

const ConfirmationButtons = ({
    onCancel,
    onSubmit,
    cancelText,
    submitText,
    isDisabled,
    className,
    cancelButtonVariant = FQ_BUTTON_VARIANTS.fqOutline,
    submitButtonVariant = FQ_BUTTON_VARIANTS.fqOutline,
    cancelButtonColor = FQ_BUTTON_COLOR_VARIANTS.fqRed,
    submitButtonColor = FQ_BUTTON_COLOR_VARIANTS.fqGreen,
    justifyContent,
    disabledSubmit,
}: IConfirmationButtonsProps) => {
    const { t } = useTranslation();

    const disabledSubmitButton = isDisabled || disabledSubmit;

    return (
        <div className={className}>
            <ButtonsWrapper justifyContent={justifyContent}>
                <FQButton
                    data-testid="cancel-button"
                    data-variant={cancelButtonVariant}
                    color={cancelButtonColor}
                    onClick={onCancel}
                    disabled={isDisabled}
                >
                    {cancelText || t('alert_defaultDeclineAction_title')}
                </FQButton>

                <FQButton
                    data-testid="submit-button"
                    data-variant={submitButtonVariant}
                    color={submitButtonColor}
                    onClick={onSubmit}
                    disabled={disabledSubmitButton}
                    type="submit"
                >
                    {submitText || t('imagePicker_saveButton_title')}
                </FQButton>
            </ButtonsWrapper>
        </div>
    );
};

const Memoized = memo(ConfirmationButtons);
const Styled = styled(Memoized)``;

const ButtonsWrapper = styled.div<{ justifyContent?: string }>`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) => justifyContent ?? 'flex-end'};
    gap: 1rem;

    @media screen and (width < ${MEDIA_QUERIES_BREAKPOINTS.stablet}px) {
        justify-content: center;
    }
    @media screen and (width <= ${MEDIA_QUERIES_BREAKPOINTS.mobile}px) {
        flex-direction: column;
    }
`;

export default Styled;
